// AttendanceStatusBadge — DRY: one attendance-status pill (present / absent / excused) for the
// student, tutor and admin pages. Shows the raw status.
import Badge from "./Badge.js";
import type { AttendanceStatus } from "@dm-lms/shared/types";

const TONE_BY_STATUS: Record<AttendanceStatus, "green" | "red" | "gold"> = {
  present: "green",
  absent:  "red",
  excused: "gold",
};

export default function AttendanceStatusBadge({ status }: { status: AttendanceStatus }) {
  return <Badge tone={TONE_BY_STATUS[status]}>{status}</Badge>;
}
